var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02807e-07 43.9992H48V47.9992H1.02807e-07V43.9992ZM48 15.8172V19.9992H42V35.9992H46V39.9992H2V35.9992H6V19.9992H1.02807e-07V15.8172C-0.000199409 14.7392 0.28999 13.6812 0.840066 12.7542C1.39014 11.8272 2.17979 11.0655 3.126 10.5492L21.126 0.731159C22.0072 0.248878 22.9955 -0.00390625 24 -0.00390625C25.0045 -0.00390625 25.9928 0.248878 26.874 0.731159L44.874 10.5492C45.8202 11.0655 46.6099 11.8272 47.1599 12.7542C47.71 13.6812 48.0002 14.7392 48 15.8172ZM10 35.9992H16V19.9992H10V35.9992ZM20 19.9992V35.9992H28V19.9992H20ZM38 19.9992H32V35.9992H38V19.9992ZM44 15.8172C44.0001 15.4579 43.9033 15.1052 43.72 14.7962C43.5366 14.4872 43.2734 14.2333 42.958 14.0612L24.958 4.24316C24.6642 4.08281 24.3348 3.99879 24 3.99879C23.6652 3.99879 23.3358 4.08281 23.042 4.24316L5.042 14.0612C4.7266 14.2333 4.46338 14.4872 4.28002 14.7962C4.09666 15.1052 3.99993 15.4579 4 15.8172V15.9992H44V15.8172Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank 1.510a8da640abec870543ec1978e20fc8.svg";
export { ForwardRef as ReactComponent };